<IFA-header></IFA-header>

<main id="primary" class="site-main customMain">
  <section
    id="about-insurance"
    class="section-insur types-mutual-fund-section mt-40">
    <div class="container">
      <!-- <div class='d-flex flex-row'>
        <div class='flex-fill'>
          <div class="col-12">
            <div class="sb-tag sb-offerings mb-12">
              mutual funds
            </div>
            <h2 class="wealth-section-title mb-6">
              What are Mutual Funds?
            </h2>
            <p class="wealth-section-description">
              Explore Mutual Funds a bit more.
            </p>
          </div>
        </div>
      </div> -->
      <div class="pt-8 tab-wrapper mutual-fund-type mt-5 md:pt-6 mobile">
        <div class="overflow-x-auto sm:-ml-4 width-xll">
          <div class="inline-block min-w-full align-middle">
            <ul
              class="CustomNavigation nav nav-tabs flex flex-no-wrap mb-1 text-center border-b-2 border-gray-200 tabs">
              <li
                class="active w-1/4 p- text-base font-semibold text-gray-500 whitespace-no-wrap border-b-2 border-white cursor-pointer sm:w-full min-w-9 lg:text-sm tab-link">
                <a data-toggle="tab" class="active" href="#mutual-1">
                  What are MF
                </a>
              </li>
              <li
                class="w-1/4 p- text-base font-semibold text-gray-500 whitespace-no-wrap border-b-2 border-white cursor-pointer sm:w-full min-w-9 lg:text-sm tab-link">
                <a data-toggle="tab" href="#mutual-2">Types of MF</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="tab-content">
          <div id="mutual-1" class="tab-pane fade in active show">
            <div
              class="wealth-creation-features wealth-section-space px-2L mobilecontentBox mt-30 mobilemb-10 mobilemt-5">
              <div class="row">
                <div class="col-12">
                  <div class="valign-wrapper">
                    <a
                      class="hh66Card cur-po animated fadeInUp"
                      target="_self"
                      id="homeBox1"
                      href="mf/Mutual-Fund">
                      <img
                        class="hh66CardImg"
                        src="../../../assets/images/img/icon/LandingPage_MutualFunds.svg"
                        width="49"
                        height="49"
                        alt="MF - Optimum" />
                      <div class="hh66CardText">
                        What are Mutual Funds? Introduction & More
                      </div>
                    </a>
                    <a
                      class="hh66Card cur-po animated fadeInUp"
                      target="_self"
                      id="homeBox2"
                      href="mf/Types_Of_MF">
                      <img
                        class="hh66CardImg"
                        src=".../../../assets/images/img/icon/LandingPage_TypesOfMFs.svg"
                        alt="Stocks - Optimum" />
                      <div class="hh66CardText">
                        Various Types of Mutual Funds
                      </div>
                    </a>
                  </div>

                  <div class="valign-wrapper">
                    <a
                      class="hh66Card cur-po animated fadeInUp"
                      target="_self"
                      id="homeBox2"
                      href="mf/SIP">
                      <img
                        class="hh66CardImg"
                        src="../../../assets/images/img/icon/LandingPage_SIP.svg"
                        alt="Stocks - Optimum" />
                      <div class="hh66CardText">
                        What is SIP? Systematic Investment Plan
                      </div>
                    </a>
                    <a
                      class="hh66Card cur-po animated fadeInUp"
                      target="_self"
                      id="homeBox1"
                      href="mf/categorization-of-mutual-funds">
                      <img
                        class="hh66CardImg"
                        src="../../../assets/images/img/icon/LandingPage_Advantages_MFs.svg"
                        alt="MF - Optimum" />
                      <div class="hh66CardText">Advantages of Mutual Funds</div>
                    </a>
                  </div>
                  <div class="valign-wrapper">
                    <a
                      class="hh66Card cur-po animated fadeInUp"
                      target="_self"
                      id="homeBox1"
                      href="mf/categorization-of-mutual-funds">
                      <img
                        class="hh66CardImg"
                        src="../../../assets/images/img/icon/LandingPage_CategoryOfMFs.svg"
                        alt="MF - Optimum" />
                      <div class="hh66CardText">
                        Categorisation of Mutual Funds
                      </div>
                    </a>
                    <a
                      class="hh66Card cur-po animated fadeInUp"
                      target="_self"
                      id="homeBox1"
                      href="mf/risks-in-mutual-funds">
                      <img
                        class="hh66CardImg"
                        src="../../../assets/images/img/icon/LandingPage_RisksFactors.svg"
                        alt="MF - Optimum" />
                      <div class="hh66CardText">
                        Risk Factors in Mutual Funds
                      </div>
                    </a>
                  </div>

                  <div class="valign-wrapper">
                    <a
                      class="hh66Card cur-po animated fadeInUp"
                      target="_self"
                      id="homeBox1"
                      href="mf/FAQ#Myth">
                      <img
                        class="hh66CardImg"
                        src="../../../assets/images/img/icon/LandingPage_MythsFacts.svg"
                        alt="MF - Optimum" />
                      <div class="hh66CardText">
                        Myths & Facts about Mutual Funds
                      </div>
                    </a>
                    <a
                      class="hh66Card cur-po animated fadeInUp"
                      target="_self"
                      id="homeBox1"
                      href="mf/FAQ#FAQ">
                      <img
                        class="hh66CardImg"
                        src="../../../assets/images/img/icon/LandingPage_NAV.svg"
                        alt="MF - Optimum" />
                      <div class="hh66CardText">What is NAV? & Other FAQs</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="mutual-2" class="tab-pane fade">
            <div
              class="wealth-creation-features wealth-section-space px-2L mobilecontentBox mt-30">
              <div class="row">
                <div class="col-md-12 col-xs-12">
                  <div class="valign-wrapper">
                    <a
                      class="hh66Card hh66Card_Mob cur-po animated fadeInUp"
                      target="_self"
                      id="homeBox1"
                      href="mf/Types_Of_MF">
                      <img
                        class="hh66CardImg"
                        src="../../../assets/images/img/icon/TypesOfMF_Icons/EquityFunds.svg"
                        width="49"
                        height="49"
                        alt="MF - Optimum" />
                      <div class="hh66CardText hh66CardText_Mob">
                        Equity Funds
                      </div>
                    </a>
                    <a
                      class="hh66Card hh66Card_Mob cur-po animated fadeInUp"
                      target="_self"
                      id="homeBox2"
                      href="mf/Types_Of_MF">
                      <img
                        class="hh66CardImg"
                        src="../../../assets/images/img/icon/TypesOfMF_Icons/DebtFunds.svg"
                        width="49"
                        height="49"
                        alt="Stocks - Optimum" />
                      <div class="hh66CardText hh66CardText_Mob">
                        Debt Funds
                      </div>
                    </a>
                  </div>
                  <div class="valign-wrapper">
                    <a
                      class="hh66Card hh66Card_Mob cur-po animated fadeInUp"
                      target="_self"
                      id="homeBox2"
                      href="mf/Types_Of_MF">
                      <img
                        class="hh66CardImg"
                        src="../../../assets/images/img/icon/TypesOfMF_Icons/LiquidFunds.svg"
                        width="49"
                        height="49"
                        alt="Stocks - Optimum" />
                      <div class="hh66CardText hh66CardText_Mob">
                        Liquid Funds
                      </div>
                    </a>
                    <a
                      class="hh66Card hh66Card_Mob cur-po animated fadeInUp"
                      target="_self"
                      id="homeBox1"
                      href="mf/Types_Of_MF">
                      <img
                        class="hh66CardImg"
                        src="../../../assets/images/img/icon/TypesOfMF_Icons/BalancedAdvantage.svg"
                        width="49"
                        height="49"
                        alt="MF - Optimum" />
                      <div class="hh66CardText hh66CardText_Mob">
                        Balanced Funds
                      </div>
                    </a>
                  </div>

                  <div class="valign-wrapper">
                    <a
                      class="hh66Card hh66Card_Mob cur-po animated fadeInUp"
                      target="_self"
                      id="homeBox1"
                      href="mf/Types_Of_MF">
                      <img
                        class="hh66CardImg"
                        src="../../../assets/images/img/icon/TypesOfMF_Icons/TaxSaverFunds.svg"
                        width="49"
                        height="49"
                        alt="MF - Optimum" />
                      <div class="hh66CardText hh66CardText_Mob">
                        Tax Saving ELSS
                      </div>
                    </a>
                    <a
                      class="hh66Card hh66Card_Mob cur-po animated fadeInUp"
                      target="_self"
                      id="homeBox1"
                      href="mf/Types_Of_MF">
                      <img
                        class="hh66CardImg"
                        src="../../../assets/images/img/icon/TypesOfMF_Icons/ETFs.svg"
                        width="49"
                        height="49"
                        alt="MF - Optimum" />
                      <div class="hh66CardText hh66CardText_Mob">
                        Exchange Traded Funds
                      </div>
                    </a>
                  </div>

                  <div class="valign-wrapper">
                    <a
                      class="hh66Card hh66Card_Mob cur-po animated fadeInUp"
                      target="_self"
                      id="homeBox1"
                      href="mf/Types_Of_MF">
                      <img
                        class="hh66CardImg"
                        src="../../../assets/images/img/icon/TypesOfMF_Icons/GoldETFs.svg"
                        width="49"
                        height="49"
                        alt="MF - Optimum" />
                      <div class="hh66CardText hh66CardText_Mob">Gold ETFs</div>
                    </a>
                    <a
                      class="hh66Card hh66Card_Mob cur-po animated fadeInUp"
                      target="_self"
                      id="homeBox1"
                      href="mf/Types_Of_MF">
                      <img
                        class="hh66CardImg"
                        src="../../../assets/images/img/icon/TypesOfMF_Icons/FundsOFunds.svg"
                        width="49"
                        height="49"
                        alt="MF - Optimum" />
                      <div class="hh66CardText hh66CardText_Mob">
                        Funds Of Funds
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
<IFA-footer></IFA-footer>
